import React from "react";
import {
  makeStyles,
  Container,
  Grid,
  Paper,
  Menu,
  MenuItem,
  useHistory,
  AuthService,
} from "../../../common";
import Commision from "../../../assets/images/com.svg";
import limit from "../../../assets/images/limit.svg";
import CashbackIcon from "../../../assets/images/cashback_rewards.svg";
import RewardIcon from "../../../assets/images/rewards.svg";
import LevelwiseAccount from "../../../assets/images/levelwise_account.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "5rem",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  my_paper: {
    height: "200px",
    textAlign: "center",
    paddingTop: "20px",
    borderRadius: "4px",
    cursor: "pointer",
    border: "1px solid #4DC06E",
    width: "256px",
  },
  box_wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "space-between",
    width: "100%",
  },
  box: {
    flex: 1,
    padding: 20,
    boxShadow: "0px 0px 2px 1px #4DC06E",
    margin: 10,
    cursor: "pointer",
  },
}));
export default function Home() {
  const classes = useStyles();
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const isMenuOpen = Boolean(anchorEl);
  let history = useHistory();

  // const handleProfileMenuOpen = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleMenuClose = () => {
  //   setAnchorEl(null);
  //   handleMobileMenuClose();
  // };
  // const handleLogout = () => {
  //   AuthService.logout();
  // };
  // const menuId = "primary-search-account-menu";
  // const renderMenu = (
  //   <Menu
  //     anchorEl={anchorEl}
  //     anchorOrigin={{ vertical: "top", horizontal: "right" }}
  //     id={menuId}
  //     keepMounted
  //     transformOrigin={{ vertical: "top", horizontal: "right" }}
  //     open={isMenuOpen}
  //     onClose={handleMenuClose}
  //   >
  //     <MenuItem onClick={handleMenuClose}>Change password</MenuItem>
  //     <MenuItem onClick={handleLogout}>Logout</MenuItem>
  //   </Menu>
  // );

  return (
    <Container maxWidth="xl" className={classes.root}>
      <Grid container spacing={3} style={{ padding: "30px 12px" }}>
        <h3
          style={{
            fontWeight: "bold",
            color: "#2B335E",
            paddingBottom: 20,
            paddingLeft: 7,
          }}
        >
          Quick Access
        </h3>

        <div className={classes.box_wrapper}>
          <div className={classes.box}>
            <img
              style={{
                width: "100px",
                marginTop: "15px",
                height: "90.27px ",
              }}
              src={LevelwiseAccount}
              alt="Account SetUp"
              onClick={() => history.push("/account-setup/view-all")}
            />
            <h4>Account SetUp</h4>
          </div>
          <div className={classes.box}>
            <img
              style={{ width: "100px", marginTop: "15px" }}
              src={Commision}
              alt="Charge"
              onClick={() => history.push("/Commission/view-all")}
            />
            <h4>Commission</h4>
          </div>
          <div className={classes.box}>
            <img
              style={{ width: "100px", marginTop: "15px" }}
              src={limit}
              alt="limit"
              onClick={() => history.push("/limit/view-all")}
            />
            <h4>Overall Limit</h4>
          </div>
          {/* <Grid item md={2}></Grid> */}
          <div className={classes.box}>
            <img
              style={{ width: "100px", marginTop: "15px" }}
              src={CashbackIcon}
              alt="Cashback"
              onClick={() => history.push("/sender-cashback/view-all")}
            />
            <h4>Sender Cashback</h4>
          </div>

          <div className={classes.box}>
            <img
              style={{ width: "100px", marginTop: "15px", padding: "10px" }}
              src={RewardIcon}
              alt="Cashback"
              onClick={() => history.push("/receiver-reward/view-all")}
            />
            <h4>Receiver Reward</h4>
          </div>
          {/* ))} */}
        </div>
      </Grid>
    </Container>
  );
}
